import { adaptRecord } from "../orm/records-mjs";
import { resolveMutation } from "./mutation-mjs";
import { resolveRelayConnection } from "./relay-mjs";
import { unwrapType } from "../utils-mjs";
import { isRelayConnectionType, isRelayEdgeType, isRelayPageInfoType } from "../relay-pagination-mjs";

function findRecord(args, context, typeName) {
  var collectionName = context.mirageSchema.toCollectionName(typeName);
  var record = context.mirageSchema[collectionName].findBy(args);
  return adaptRecord(record, typeName);
}

function isMutation(info) {
  return info.parentType === info.schema.getMutationType();
}

export default function resolveObject(obj, args, context, info, type) {
  var _unwrapType = unwrapType(info.parentType),
      parentType = _unwrapType.type;

  return isMutation(info) ? resolveMutation(args, context, info, type.name) : isRelayConnectionType(type) ? resolveRelayConnection(obj, args, context, info, type) : !obj ? findRecord(args, context, type.name) : isRelayEdgeType(parentType) ? obj.node : isRelayPageInfoType(type) ? obj.pageInfo : adaptRecord(obj[info.fieldName]);
}
